import Close from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { currencySymbol } from '@openx/utils/lib/priceFormat.ts';
import type { MouseEventHandler } from 'react';
import type { FieldValues } from 'react-hook-form';
import {
  RHFTextFieldWithAdornment,
  type RHFTextFieldWithAdornmentProps,
} from '../TextField/RHFTextFieldWithAdornment.tsx';

export type RHFCurrencyFieldProps<T extends FieldValues = Record<string, string>> = Omit<
  RHFTextFieldWithAdornmentProps<T>,
  'startAdornment' | 'endAdornment'
> & {
  onClearClick?: MouseEventHandler | false | null;
  currency?: string | false | null;
};

export const RHFCurrencyField = <T extends FieldValues = Record<string, string>>({
  dataTest = undefined,
  onClearClick = undefined,
  currency = 'USD',
  slotProps,
  ...props
}: RHFCurrencyFieldProps<T>) => {
  /** At the time of this comment - we use <input type="text"> to handle numerical values. This is most likely because of the
   * "arrows" that are displayed on the right side of focused input. However, inputs with type="number" provide under-the-hood
   * validation and restrictions as it comes to what can be typed or pasted into the input - which are missing in case of type="text".
   * Therefor handling of numerical values should be subject to discuss during upcoming UI guild meeting.
   */

  // /** Prevent non-numerical values from being paste into the input */
  // const handlePaste: ClipboardEventHandler<HTMLElement> = useCallback(e => {
  //   const value = e.clipboardData.getData('Text');
  //   if (parseFloat(value).toString() !== value) {
  //     e.stopPropagation();
  //     e.preventDefault();
  //   }
  // }, []);

  return (
    <RHFTextFieldWithAdornment<T>
      {...props}
      dataTest={dataTest}
      // onPasteCapture={handlePaste}
      slotProps={{
        htmlInput: {
          maxLength: 17 /** length of max-safe float: 70368744177663.99 // https://stackoverflow.com/questions/45929493/node-js-maximum-safe-floating-point-number*/,
        },
        ...slotProps,
      }}
      {...(typeof onClearClick === 'function' && {
        endAdornment: (
          <IconButton onClick={onClearClick} size="small" data-test={dataTest && `${dataTest}-clear-button`}>
            <Close />
          </IconButton>
        ),
      })}
      {...(currency && { startAdornment: currencySymbol(currency) })}
    />
  );
};
